import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
//import router from "./router";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(VueRouter);

Vue.config.productionTip = false;

import { routes } from "./router/index";

const router = new VueRouter({ routes: routes });

new Vue({
  router: router,
  mode: history,
  render: (h) => h(App),
}).$mount("#app");

router.beforeEach((to, from, next) => {
  var slide = document.querySelector("#slide");
  /*const slideClasses = slide.getAttribute("class").split(" ");
  const lastClass = slideClasses[slideClasses.length - 1];*/

  slide.classList.remove("slide-left");
  slide.classList.remove("slide-right");

  /*console.log(slideClasses);
  console.log(lastClass);*/

  next();
});

/*router.afterEach((to, from, next) => {
  const viewNames = [
    "Home",
    "AboutMe",
    "Experiences",
    "Game",
    "Portfolio",
    "Contacts",
  ];
  var slide = document.querySelector("#slide");*/

  /*const slideClasses = slide.getAttribute('class').split(" ");
  const lastClass = slideClasses[slideClasses.length - 1];*/

  /*slide.classList.remove("slide-left");
  slide.classList.remove("slide-right");

  if (viewNames.indexOf(from.name) > viewNames.indexOf(to.name)) {
    console.log("vai a sinistra");
    slide.classList.add("slide-left");
  } else {
    console.log("vai a destra");
    slide.classList.add("slide-right");
  }*/


  /*console.log(slideClasses);
  console.log(lastClass);*/

  /*next();
});*/
